import React from 'react'

import { withTooltip } from '@amzn/stencil-react-components/tooltip'
import { IconQuestionCircleSmall as IconQuestionCircle } from '@amzn/stencil-react-icons'

const IconWithTooltipInner = withTooltip()(IconQuestionCircle)

export function IconWithTooltip({
    title = 'Open tooltip',
    ...props
}: {
    tooltipText: string
    title?: string
    color?: string
    isInline?: boolean
}) {
    return <IconWithTooltipInner title={title} {...props} />
}
